"use client";

import React, { createContext, useState, useEffect, ReactNode } from "react";

interface CustomUIContextData {
  lastMenuRefreshDate: number | null;
  setLastMenuRefreshDate: (date: number) => void;

  companyTimeZone: string;
  setCompanyTimeZone: (timeZone: string) => void;
}

const CustomUIContext = createContext<CustomUIContextData | null>(null);

interface CustomUIProviderProps {
  children: ReactNode;
}

export const CustomUIProvider: React.FC<CustomUIProviderProps> = ({
  children,
}) => {
  const [lastMenuRefreshDate, setLastMenuRefreshDate] = useState<number | null>(
    null,
  );

  const [companyTimeZone, setCompanyTimeZone] = useState("UTC");

  return (
    <CustomUIContext.Provider
      value={{
        lastMenuRefreshDate,
        setLastMenuRefreshDate,
        companyTimeZone,
        setCompanyTimeZone,
      }}
    >
      {children}
    </CustomUIContext.Provider>
  );
};

export default CustomUIContext;
